import React, {useEffect, useState} from 'react';
import Button from '../Components/Button';
import {theme} from 'antd';
import {HAPPY_PAY_PUBLIC, LOGIN_CLOSED} from '../config/campaign';

const SideBar = ({show}) => {

    let style = "";
    if (show === true) {
        style = 'px-3.5 hidden mobile:flex flex-col items-center w-72 h-screen text-[#0987F3] bg-white font-medium fixed z-50 pt-8 space-y-6 translate-x-0 transition duration-300 ease-in-out delay-75 ';
    } else {
        style = 'px-3.5 hidden mobile:flex flex-col items-center w-72 h-screen text-[#0987F3] bg-white font-medium fixed z-50 pt-8 space-y-6 -translate-x-72 transition duration-300 ease-in-out delay-75';
    }

    const {useToken} = theme;
    const [lang, setLang] = useState('eng');
    const [loginButton, setLoginButton] = useState({link: '/login', name: 'Нэвтрэх'});

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('localData'));
        if (items) {
            setLoginButton({link: '/dashboard', name: 'Хэрэглэгч'});
        }
    }, []);

    return (
        <div className={style}>
            <a className='flex justify-center items-center w-52' href="/"><img className='w-40'
                                                                               src="/images/TDB_loyalty.png"/></a>
            <Button
                style="w-full h-fit py-3 hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 rounded-lg cursor-pointer"
                link={"/infosaving"} name={"Хуримтлалтай Монгол"} name2={"Хадгаламжийн урамшуулалт аян"}/>
            {/*<Button*/}
            {/*    style="w-full h-fit py-3 hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 rounded-lg cursor-pointer"*/}
            {/*    link={"/infovisa"} name={"HAPPY PAY"} name2={"Картын урамшуулалт хөтөлбөр"}/>*/}
            {/*<Button*/}
            {/*    style="w-full h-fit py-3 hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 rounded-lg cursor-pointer"*/}
            {/*    link={"/infomerchant"} name={"HAPPY MERCHANT"} name2={"Жижиг дунд бизнесийн урамшуулалт хөтөлбөр"}/>*/}
            {/*<Button*/}
            {/*    style="w-full h-fit py-3 hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 rounded-lg cursor-pointer"*/}
            {/*    link={"/infoapple"} name={"APPLE PAY"} name2={"Apple pay-н урамшуулалт хөтөлбөр"}/>*/}
            {HAPPY_PAY_PUBLIC && <Button
                style="w-full h-fit py-3 hover:bg-[#0987F3] duration-300 hover:bg-opacity-20 rounded-lg cursor-pointer"
                link={"/infohappy"} name={"HAPPY PAY"} name2={"Happy pay-н урамшуулалт хөтөлбөр"}/>}
            {!LOGIN_CLOSED && <div className='py-3 w-52 flex justify-center items-center'>
                <Button
                    style="rounded-lg w-36 h-8 font-semibold text-white text-sm bottom-[30px] z-10 bg-[#0987F3] hover:text-white"
                    link={"/login"} name="Нэвтрэх"/>
            </div>}
        </div>
    );
}

export default SideBar;